import { cn } from '@/lib/utils';
import { motion } from 'framer-motion';

export const FullscreenLoading = ({ isMobile }: { isMobile: boolean }) => {
  return (
    <motion.div
      key="loading"
      className={cn(
        'flex items-center justify-center',
        !isMobile ? 'h-screen w-screen' : 'h-full w-full',
      )}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.1 }}>
      <img
        src="/logo.svg"
        alt="Voicefill"
        className="relative -top-1.5 w-27.5 animate-pulse select-none"
      />
    </motion.div>
  );
};
